import { AI_CHATBOT_ACTIONS, type AllChatbotActions } from "../actions/actions";
import type { ChatbotState } from "../types/chatbot.reducer.type";
import { appendStreamChunkToAiResponse } from "../utils/append-stream-chunk-to-ai-response";

export function messagesReducer(state: ChatbotState, action: AllChatbotActions) {
  switch (action.type) {
    case AI_CHATBOT_ACTIONS.POPULATE_CHAT_MESSAGES:
      return {
        ...state,
        messages: action.payload.messages ?? [],
      };

    case AI_CHATBOT_ACTIONS.ADD_USER_MESSAGE_ACTION:
    case AI_CHATBOT_ACTIONS.ADD_AI_RESPONSE_ACTION:
      return {
        ...state,
        messages: [...state.messages, action.payload.message],
      };
    case AI_CHATBOT_ACTIONS.CLEAR_CHAT_MESSAGES:
      return {
        ...state,
        messages: [],
      };
    case AI_CHATBOT_ACTIONS.ADD_AI_RESPONSE_STREAM_ACTION:
      if (action.payload.message) {
        return {
          ...state,
          messages: appendStreamChunkToAiResponse(state.messages, action.payload.message),
        };
      }
      return state;

    default:
      return {};
  }
}
